import React from 'react';

export type LoadingSpinnerVariant = 'inline' | 'page' | 'fullscreen';

interface LoadingSpinnerProps {
  message?: string;
  /** inline: داخل بخش · page: وسط صفحه · fullscreen: تمام صفحه */
  variant?: LoadingSpinnerVariant;
  /** برای سازگاری با فراخوانی‌های قبلی — نادیده گرفته می‌شود */
  showSlogan?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  variant = 'inline',
}) => {
  const shellClass =
    variant === 'fullscreen'
      ? 'fixed inset-0 z-[100] bg-slate-50/90 flex items-center justify-center'
      : variant === 'page'
        ? 'flex w-full min-h-[calc(100dvh-3.5rem)] items-center justify-center'
        : 'flex items-center justify-center py-6';

  return (
    <div className={shellClass} dir="rtl" role="status" aria-live="polite" aria-busy="true">
      <div className="flex flex-col items-center gap-2.5">
        <div
          className="h-8 w-8 rounded-full border-2 border-emerald-200 border-t-[#0a4d29] animate-spin"
          aria-hidden
        />
        {message ? <p className="text-xs text-slate-500">{message}</p> : null}
        <span className="sr-only">{message || 'در حال بارگذاری'}</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
